/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1AccountNumberEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_ACCOUNT_NUMBER_EVENT_ENTITY_NAME = 'ixc.funding.v1.AccountNumberEvent';
export const ixcFundingV1AccountNumberEventEntity = new schema.Entity<IxcFundingV1AccountNumberEvent>(IXC_FUNDING_V1_ACCOUNT_NUMBER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcFundingV1AccountNumberEvent) => `${entity.metadata?.eventId}` });

